<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="config-form">
      <div class="form-item">
        <label class="item-title">前端名称:</label>
        <el-input :value="appInfo.name || '物流保险师'" disabled />
      </div>
      
      <div class="form-item">
        <label class="item-title">配置名称:</label>
        <el-input v-model="formData.name" placeholder="请输入配置名称" :disabled="isView" />
      </div>
      
      <div class="form-item">
        <label class="item-title">系统类型:</label>
        <div class="radio-group">
          <span 
            class="reset-radio" 
            :class="{ on: formData.os_type === 1 }" 
            @click="!isView && (formData.os_type = 1)"
          >
            Android
          </span>
          <span 
            class="reset-radio" 
            :class="{ on: formData.os_type === 2 }" 
            @click="!isView && (formData.os_type = 2)"
          >
            iOS
          </span>
        </div>
      </div>
      
      <div class="form-item upload-item">
        <label class="item-title">上传引导页:</label>
        <div class="upload-section">
          <div class="upload-btn" v-if="!isView">
            <input 
              type="file" 
              ref="fileInput"
              @change="handleFileUpload"
              accept="image/*"
              multiple
              style="display: none"
            />
            <el-button type="primary" @click="$refs.fileInput.click()">上传</el-button>
          </div>
          <p class="upload-tip">图片尺寸：750*1334 图片格式：jpg/png，限制5张</p>
          <div class="pic-preview" v-if="formData.guide && formData.guide.length > 0">
            <div class="pic-item" v-for="(item, index) in formData.guide" :key="index">
              <span 
                class="reset-dir left" 
                v-if="formData.guide.length > 1 && !isView" 
                @click="changePos('left', index)"
              >
                &larr;
              </span>
              <span 
                class="reset-dir right" 
                v-if="formData.guide.length > 1 && !isView" 
                @click="changePos('right', index)"
              >
                &rarr;
              </span>
              <a :href="item" target="_blank">
                <img :src="item" width="80" alt="点击查看大图" />
              </a>
              <p class="del-pic" v-if="!isView" @click="removeImage(index)">删 除</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer" v-if="!isView">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveGuide, getGuideInfo } from '@/api/custom-frontend'

export default {
  name: 'GuideEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    guideData: {
      type: Object,
      default: null
    },
    appInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      formData: {
        id: null,
        app_id: null,
        name: '',
        os_type: 1,
        type: 3, // 引导页类型
        guide: []
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    
    dialogTitle() {
      if (this.isView) return '查看'
      return this.guideData ? '编辑' : '添加'
    },
    
    isView() {
      return this.guideData && this.guideData.action === 'view'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData()
      }
    }
  },
  methods: {
    async initFormData() {
      if (this.guideData && this.guideData.id) {
        // 编辑模式，获取详细信息
        try {
          const res = await getGuideInfo({ id: this.guideData.id })
          if (res && res.err_code === 0) {
            this.formData = {
              id: res.data.id,
              app_id: res.data.app_id,
              name: res.data.name,
              os_type: res.data.os_type,
              type: res.data.type,
              guide: res.data.config && res.data.config.guide ? res.data.config.guide : []
            }
          }
        } catch (error) {
          console.error('获取引导页详情失败:', error)
        }
      } else {
        // 新增模式
        this.formData = {
          id: null,
          app_id: this.appInfo.id,
          name: '',
          os_type: 1,
          type: 3,
          guide: []
        }
      }
    },
    
    async handleFileUpload(event) {
      const files = Array.from(event.target.files)
      if (!files.length) return
      
      // 检查数量限制
      if (this.formData.guide.length + files.length > 5) {
        this.$message.error('最多上传五张')
        return
      }
      
      this.uploadLoading = true
      
      try {
        const token = this.$store.getters.token
        
        for (const file of files) {
          // 文件类型验证
          const isImage = file.type.startsWith('image/')
          if (!isImage) {
            this.$message.error('只能上传图片文件')
            continue
          }
          
          // 文件大小验证
          const isLt5M = file.size / 1024 / 1024 < 5
          if (!isLt5M) {
            this.$message.error('图片大小不能超过5MB')
            continue
          }
          
          const formData = new FormData()
          formData.append('file', file)
          
          try {
            const response = await fetch(`${process.env.VUE_APP_BASE_URL}/res/file/upload`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`
              },
              body: formData
            })
            
            const result = await response.json()
            
            if (result.err_code === 0) {
              this.formData.guide.push(result.data)
            } else {
              this.$message.error(result.err_msg || '上传失败')
            }
          } catch (error) {
            console.error('上传失败:', error)
            this.$message.error('上传失败')
          }
        }
        
        if (this.formData.guide.length > 0) {
          this.$message.success('上传成功')
        }
      } finally {
        this.uploadLoading = false
        // 清空文件输入
        this.$refs.fileInput.value = ''
      }
    },
    
    removeImage(index) {
      this.formData.guide.splice(index, 1)
    },
    
    changePos(dir, index) {
      const guide = this.formData.guide
      if (dir === 'left' && index === 0) {
        // 最左的元素移到最右
        const temp = guide.shift()
        guide.push(temp)
      } else if (dir === 'right' && index === guide.length - 1) {
        // 最右的元素移到最左
        const temp = guide.pop()
        guide.unshift(temp)
      } else {
        // 中间位置的元素
        const temp = guide.splice(index, 1)[0]
        if (dir === 'left') {
          guide.splice(index - 1, 0, temp)
        } else {
          guide.splice(index + 1, 0, temp)
        }
      }
    },
    
    checkData() {
      if (!this.formData.name) {
        this.$message.error('请输入配置名称')
        return false
      }
      if (!this.formData.guide.length) {
        this.$message.error('请上传引导页')
        return false
      }
      return true
    },
    
    async handleSubmit() {
      if (!this.checkData()) return
      
      this.submitLoading = true
      
      try {
        const submitData = {
          app_id: this.formData.app_id,
          name: this.formData.name,
          os_type: this.formData.os_type,
          type: this.formData.type,
          image_config: {
            guide: this.formData.guide
          }
        }
        
        if (this.formData.id) {
          submitData.id = this.formData.id
        }
        
        const res = await saveGuide(submitData)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('refresh')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存引导页失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.submitLoading = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.formData = {
        id: null,
        app_id: null,
        name: '',
        os_type: 1,
        type: 3,
        guide: []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.config-form {
  padding: 20px;
  
  .form-item {
    margin-bottom: 20px;
    
    .item-title {
      display: inline-block;
      width: 85px;
      font-weight: normal;
    }
    
    /deep/ .el-input {
      width: 430px;
      
      .el-input__inner {
        height: 30px;
        line-height: 30px;
        border: 1px solid #95B8E7;
        border-radius: 3px;
      }
    }
    
    .radio-group {
      display: inline-block;
      
      .reset-radio {
        position: relative;
        display: inline-block;
        width: 80px;
        height: 26px;
        line-height: 26px;
        border: 1px solid #eee;
        border-radius: 3px;
        text-align: center;
        cursor: pointer;
        margin-right: 10px;
        
        &.on {
          border-color: #95B8E7;
          background-color: #f0f9ff;
        }
        
        &:hover {
          border-color: #95B8E7;
        }
      }
    }
  }
  
  .upload-item {
    .upload-section {
      display: inline-block;
      vertical-align: top;
      width: calc(100% - 85px);
      
      .upload-btn {
        margin-bottom: 10px;
      }
      
      .upload-tip {
        color: red;
        font-size: 12px;
        margin-bottom: 15px;
      }
      
      .pic-preview {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        
        .pic-item {
          position: relative;
          display: inline-block;
          
          img {
            border: 1px solid #ddd;
            border-radius: 4px;
          }
          
          .reset-dir {
            position: absolute;
            top: 0;
            width: 50%;
            height: 22px;
            line-height: 15px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            font-size: 16px;
            font-weight: 900;
            text-align: center;
            cursor: pointer;
            display: block;
            
            &.left {
              left: 0;
            }
            
            &.right {
              right: 0;
            }
            
            &:hover {
              background: rgba(0, 0, 0, 0.8);
            }
          }
          
          .del-pic {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 20px;
            line-height: 20px;
            background: rgba(0, 0, 0, 0.7);
            color: #fff;
            text-align: center;
            font-size: 12px;
            cursor: pointer;
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          &:hover .del-pic {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>